import { render, staticRenderFns } from "./Headbar.vue?vue&type=template&id=6ab5f0d4"
import script from "./Headbar.vue?vue&type=script&lang=js"
export * from "./Headbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports